import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UTILS } from 'src/app/core/const/const';
import { IArticle } from 'src/app/core/interfaces/article';

@Component({
  selector: 'app-card-article',
  templateUrl: './card-article.component.html',
  styleUrls: ['./card-article.component.scss']
})
export class CardArticleComponent {
  @Input() article: Partial<IArticle> = {};

  constructor(private router:Router) { }

  goToDetailArticle() {
    void this.router.navigate([
      '/article',
      UTILS.replaceSpace(this.article.title),
      this.article.id,
    ]);
  }
}
